// TODO: should be marked as server-only
// import 'server-only';
import { Locale } from '@headless-workspace/config';
import { EcomConfigKeys, getCachedEcomConfigByKey, VipBrandsValue } from '../config';

export const getCachedVipBrands = async (locale: Locale) => getCachedEcomConfigByKey(locale, EcomConfigKeys.VipBrands);
